module.exports = __webpack_public_path__ + "lp/img/vote_verygood.0a315163.svg";